/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NumberOfStartups } from './numberOfStartups';


export interface StatusCodeValueNumberOfStartups { 
    value?: NumberOfStartups;
    status_code?: number;
}

